<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card :class="{ 'remove_card': propOpenedInModal }">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmGPathCareertypeFormData && Object.keys(vmGPathCareertypeFormData).length > 0">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationcarr_field" class="w-100">{{cvCarrImageLabel}}</label>
                  <div class="profile-img-edit border border-dark" style="height: 150px; width: 150px; border-radius: 50%; ">
                    <div v-if="vmProfilePic" >
                    <img alt="profile-pic" :src="vmProfilePic" style="width: 100%; object-fit: contain; overflow: hidden; border-radius: 50%; "/>
                    <button v-if="vmProfilePic" class="btn btn-primary ml-5 mt-1" @click="()=>imageEdit('Profile Pic')">
                      Save
                    </button>
                  </div>
                    <i v-else class="fas fa-orgersity d-flex justify-content-center align-items-center rounded-circle " style="font-size: 5rem; height:100%; "></i>
                    <label class="p-image">
                      <i class="ri-pencil-line upload-button" title="Update image" style="cursor: pointer" ></i>
                      <input class="file-upload" type="file" accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0;" @change="openImageDialog($event, 'Profile Pic')" />
                    </label>
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvNameLabel}}</label>
                  <multiselect
                    v-model="vmGPathCareertypeFormData.name"
                    :tag-placeholder="cvSelectLabel"
                    :placeholder="cvSelectLabel"
                    :searchable="true"
                    :options="gpathCareerName"
                    :taggable="true"
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationname">
                    {{cvName2Label}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.name2"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationkey">
                    {{cvKeyLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.career_key"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">
                    {{cvTitleLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.title"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdetail">
                    {{cvDetailLabel}}</label>
                  <textarea
                    v-model="vmGPathCareertypeFormData.detail"
                    type="text"
                    class="textarea form-control"
                    required></textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationabout">
                    {{cvAboutLabel}}</label>
                  <textarea
                    v-model="vmGPathCareertypeFormData.about"
                    type="text"
                    class="textarea form-control"
                    required></textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationkey">
                    {{cvUrlLabel}}</label>
                  <input
                    v-model="vmGPathCareertypeFormData.url"
                    type="text"
                    class="form-control"
                    required/>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvSalaryLabel}}</label>
                    <ValidationProvider
                      name="salary"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.salary"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvSubjectLabel}}</label>
                    <ValidationProvider
                      name="subjects"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.subjects"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvProgramsLabel}}</label>
                    <ValidationProvider
                      name="programs"
                      rules="required"
                      v-slot="{ errors }">
                      <input
                        v-model="vmGPathCareertypeFormData.programs"
                        type="text"
                        class="form-control"
                        required/>
                      <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerPathsLabel}}</label>
                    <ValidationProvider
                      name="Career Roles"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_paths"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerRolesLabel}}</label>
                    <ValidationProvider
                      name="Career Roles"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_roles"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerFactsLabel}}</label>
                    <ValidationProvider
                      name="Career facts"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_facts"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvHiringCompaniesLabel}}</label>
                    <ValidationProvider
                      name="Hiring Companies"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.hiring_companies"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationtitle">{{cvCareerMythsLabel}}</label>
                    <ValidationProvider
                      name="Hiring Companies"
                      rules="required"
                      v-slot="{ errors }">
                    <vue-editor v-model="vmGPathCareertypeFormData.career_myths"></vue-editor>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpath_career_roleEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { GPathCareers } from "../../../FackApi/api/GPathCareer"
import { GPathCareerType } from "../../../FackApi/api/GPathCareerType.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"
import { ValidationProvider } from "vee-validate"
import CropImage from "../../../components/cropImage.vue"
import { Images } from "../../../FackApi/api/image.js"
import Multiselect from "vue-multiselect"

export default {
  name: "GPathCareertypeEdit",
  components: {
    CropImage,
    VueEditor,
    ValidationProvider,
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propGPathCareertypeObj: {
      type: Object,
      default: function () {
        return {
          "name": "",
          "name2": "",
          "career_key": "",
          "title": "",
          "detail": "",
          "about": "",
          "url": "",
          "salary": "",
          "subjects": "",
          "programs": "",
          "career_paths": "",
          "career_roles": "",
          "career_facts": "",
          "hiring_companies": "",
          "career_myths": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "gpath_career_type_edit",
      cvCardTitle: "Edit GPaths Career Type",
      cvCardSubHeader: "Edit GPaths Career Type",
      cvSubmitBtn: "Edit",
      cvNameLabel: "name",
      cvSelectLabel: "Select ",
      cvName2Label: "name2",
      cvKeyLabel: "key",
      cvTitleLabel: "Title",
      cvDetailLabel: "Detail",
      cvAboutLabel: "About",
      cvUrlLabel: "Url",
      cvSalaryLabel: "Salary",
      cvSubjectLabel: "subjects",
      cvProgramsLabel: "programs",
      cvCareerPathsLabel: "Career Paths",
      cvCareerRolesLabel: "Career Roles",
      cvCareerFactsLabel: "Career Facts",
      cvHiringCompaniesLabel: "Hiring Companies",
      cvCareerMythsLabel: "Career Myths",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPaths Career Type Edit",
      vmGPathCareertypeFormData: {},
      cvCarrImageLabel: "Career Image",
      vmProfilePic: "",
      fileSrc: "",
      propCropDialogSize: "md",
      propCropImageDialogOpen: false,
      propStencilSize: null,
      vmCareerProPicImage: Object.assign({}, this.initImageData()),
      addImage: false,
      gpathCareerName: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.gpath_career_typeView()
    this.imageGetProfileImages()
    this.gpath_careerList()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathCareertypeFormData) {
          if (!this.vmGPathCareertypeFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpath_career_typeView
     */
    async gpath_career_typeView () {
      try {
        if (this.propOpenedInModal) {
          this.vmGPathCareertypeFormData = this.propGPathCareertypeObj
        }
        else {
          let gpathCareerTypeTitle = this.$route.params.gpct_id
          let gpathCareerTypeViewResp = await GPathCareerType.gpath_career_typeView(this, gpathCareerTypeTitle)

          if (gpathCareerTypeViewResp && gpathCareerTypeViewResp.resp_status) {
            this.vmGPathCareertypeFormData = gpathCareerTypeViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_typeView() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_roleEdit
     */
    async gpath_career_roleEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        if (this.addImage) {
          await this.imageAdd(this.propGPathCareertypeObj.gpct_id)
        }

        let gpathCareerTypeEditResp = await GPathCareerType.gpath_career_roleEdit(this, this.vmGPathCareertypeFormData)
        await ApiResponse.responseMessageDisplay(this, gpathCareerTypeEditResp)

        if (gpathCareerTypeEditResp && !gpathCareerTypeEditResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathCareertypeEditModal", this.vmGPathCareertypeFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_roleEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        module_id: this.propGPathCareertypeObj.gpct_id,
        module_name: "GPCT",
        image: [],
        image_type: {}
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)

      if (imageType === "Profile Pic") {
        this.vmCareerProPicImage = Object.assign({}, this.initImageData())
        this.vmCareerProPicImage.image.push(
          {
            "img": img,
            "name": orgImg.name
          }
        )
        this.vmCareerProPicImage.image_type[orgImg.name] = 2
      }
      else {
        this.vmOrganisationCoverPicImage = Object.assign({}, this.initImageData())
        this.vmOrganisationCoverPicImage.image.push(
          {
            "img": img,
            "name": orgImg.name
          }
        )
        this.vmOrganisationCoverPicImage.image_type[orgImg.name] = 3
      }
    },
    /**
     * imageRemove
     */
    async imageRemove (imgType) {
      if (imgType === "profile_pic") {
        this.cvDelProfilePicLoading = true
      }
      else {
        this.cvDelCoverPicLoading = true
      }

      let img = imgType === "profile_pic" ? 2 : 3
      const imageUpdateResp = await Images.imageDelete(this, this.$route.params.org_id, img)
      await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
      if (imageUpdateResp && !imageUpdateResp.resp_status) {
        return false
      }

      if (imgType === "profile_pic") {
        this.vmProfilePic = ""
        this.cvDelProfilePicLoading = false
      }
      else {
        this.vmCoverPic = ""
        this.cvDelCoverPicLoading = false
      }
    },
    /**
     * openImageDialog
     */
    openImageDialog (e, imageType) {
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }

      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 4 * 1024 * 1024
        this.toastVariant = "danger"
        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          return false
        }

        this.toastVariant = ""
        if (imageType === "Profile Pic") {
          this.propStencilSize = {
            "width": 150,
            "height": 150
          }
          this.propCropDialogSize = "md"
        }
        else {
          this.propStencilSize = {
            "width": 970,
            "height": 240
          }
          this.propCropDialogSize = "xl"
        }
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * imageGetProfileImages()
     */
    async imageGetProfileImages () {
      try {
        let gpctCarId
        if (this.propOpenedInModal) {
          gpctCarId = this.propGPathCareertypeObj.gpct_id
        }

        let imageProfileResp = await Images.imageListProfileImages(this, gpctCarId)
        if (imageProfileResp && !imageProfileResp.resp_status) {
          return false
        }
        else {
          this.profilePicObj = imageProfileResp.resp_data.profile_pic
          this.vmProfilePic = imageProfileResp.resp_data.profile_pic ? imageProfileResp.resp_data.profile_pic.image_thumbnail : ""
        }

        if (!imageProfileResp.resp_data.profile_pic) {
          this.addImage = true
        }
      }
      catch (err) {
        console.error("Exception occurred at imageGetProfileImages() and Exception:", err.message)
      }
    },
    /**
     * imageEdit
     */
    async imageEdit (imageType) {
      if (imageType === "Profile Pic" && this.vmCareerProPicImage.image.length === 0) {
        return false
      }

      if (imageType === "Cover Pic" && this.vmOrganisationCoverPicImage.image.length === 0) {
        return false
      }

      try {
        let image
        if (imageType === "Profile Pic") {
          this.cvProfilePicLoading = true
          image = this.vmCareerProPicImage
        }
        else {
          this.cvCoverPicLoading = true
          image = this.vmOrganisationCoverPicImage
        }

        const imageUpdateResp = await Images.imageProfileUpdate(this, image)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }

        let imageResp = imageUpdateResp.resp_data
        if (imageResp && imageResp.length > 0) {
          if (imageType === "Profile Pic") {
            this.profilePicObj = imageResp[0]
          }
          else {
            this.coverPicObj = imageResp[0]
          }
        }
        this.vmCareerProPicImage = Object.assign({}, this.initImageData())
      }
      catch (err) {
        console.error("Exception occurred at imagEdit() and Exception:", err.message)
      }
      finally {
        if (imageType === "Profile Pic") {
          this.cvProfilePicLoading = false
        }
        else {
          this.cvCoverPicLoading = false
        }
      }
    },
    /**
    * onChangeProfileImage
    */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * imageAdd
     */
    async imageAdd (gpctId) {
      if (this.cvImageError) {
        return
      }
      try {
        this.cvImageLoadingStatus = true
        let imageObj = {
          "module_name": "GPCT",
          "module_id": gpctId,
          "image": []
        }

        if (imageObj.image.length < 1) {
          return false
        }

        const imageUpdateResp = await Images.imageProfileAdd(this, imageObj)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }
        this.vmCarProPicImage = Object.assign({}, this.initImageData())
      }
      catch (err) {
        console.error("Exception occurred at imageAdd() and Exception:", err.message)
      }
      finally {
        this.cvImageLoadingStatus = false
      }
    },
    /**
     * gpath_careerList
     */
    async gpath_careerList () {
      try {
        let gpathCareerListResp = await GPathCareers.gpath_careerList(this, this.whereFilter)
        if (gpathCareerListResp.resp_status) {
          this.gpath_careerObjList = gpathCareerListResp.resp_data.data
          this.gpathCareerName = this.gpath_careerObjList.map(item => item.name)
          this.totalRows = gpathCareerListResp.resp_data.count
        }
        else {
          this.toastMsg = gpathCareerListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_careerList() and Exception:", err.message)
      }
    }
  }
}
</script>

<style scoped>
textarea{
  height: 195px !important;
  overflow-y: scroll;
  line-height: 18px !important;
}
</style>
